import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, User, ChevronDown } from "react-feather";
import { clearSession } from "../../../util/auth";
import { logout } from "../../../store/auth";
import { storeDispatch } from "../../../store";

const UserHeader = () => {
  const history = useNavigate();
  const [name, setName] = useState("User");
  const [userType, setUserType] = useState("");
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setName(localStorage.getItem("Name") || "User");
    try {
      const stored = localStorage.getItem("user_data");
      if (stored) setUserType(JSON.parse(stored).userType || "");
    } catch {}
  }, []);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    clearSession();
    storeDispatch(logout());
    history("/login");
  };

  const menuItem = {
    display: "flex", alignItems: "center", gap: 10,
    padding: "10px 16px", cursor: "pointer", whiteSpace: "nowrap",
    color: "#e5e7eb", fontSize: "0.875rem",
    transition: "background 0.15s",
  };

  return (
    <li style={{ position: "relative", listStyle: "none" }} ref={dropdownRef}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: "flex", alignItems: "center", gap: 8,
          background: "none", border: "none", cursor: "pointer",
          padding: "8px 12px", borderRadius: 8,
          transition: "background 0.15s",
        }}
        onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.06)"}
        onMouseLeave={e => e.currentTarget.style.background = "none"}
      >
        <div style={{
          width: 34, height: 34, borderRadius: "50%",
          background: "#00A7AA", display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
        }}>
          <User size={16} color="#202125" />
        </div>
        <div style={{ textAlign: "left" }}>
          <div style={{ fontSize: "0.875rem", fontWeight: 500, color: "#ffffff", lineHeight: 1.2 }}>
            {name}
          </div>
          {userType && (
            <div style={{ fontSize: "0.7rem", color: "#9CA3AF", lineHeight: 1.2 }}>
              {userType}
            </div>
          )}
        </div>
        <ChevronDown
          size={14}
          color="#9CA3AF"
          style={{ marginLeft: 2, transform: open ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.2s" }}
        />
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", right: 0,
          background: "#2A2B30", border: "1px solid #3A3A3A",
          borderRadius: 8, minWidth: 160, zIndex: 9999,
          boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
          overflow: "hidden",
        }}>
          <div
            style={menuItem}
            onClick={() => { setOpen(false); history("/account"); }}
            onMouseEnter={e => e.currentTarget.style.background = "rgba(0,167,170,0.1)"}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            <User size={15} color="#9CA3AF" />
            <span>Account</span>
          </div>
          <div style={{ height: 1, background: "#3A3A3A" }} />
          <div
            style={{ ...menuItem, color: "#FF5855" }}
            onClick={handleLogout}
            onMouseEnter={e => e.currentTarget.style.background = "rgba(255,88,85,0.08)"}
            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
          >
            <LogIn size={15} color="#FF5855" />
            <span>Logout</span>
          </div>
        </div>
      )}
    </li>
  );
};

export default UserHeader;
